module.exports = __webpack_public_path__ + "img/2015079.0367780a.svg";